import axios from 'axios';
window.axios = axios;

// Set up CSRF token
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Get CSRF token from meta tag
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

// Set base URL
window.axios.defaults.baseURL = '/api';

// Request interceptor to add auth token
window.axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('auth_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for handling auth errors
window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            console.warn('401 Unauthorized response:', error.config?.url);
            
            // Only redirect to login if this is an auth endpoint or critical API
            const url = error.config?.url || '';
            const isCriticalAuth = url.includes('/auth/') || url.includes('/user') || url.includes('/dashboard/stats');
            
            if (isCriticalAuth) {
                console.log('Critical auth failure, logging out');
                localStorage.removeItem('auth_token');
                localStorage.removeItem('user');
                window.location.href = '/auth/login';
            } else {
                console.log('Non-critical 401, not logging out');
            }
        }
        return Promise.reject(error);
    }
);